/** @format */

import React from 'react'
import { FormItem, Select, Input, Option, Icon, Switch } from '@king-design/react'
import { InputTypeEnum, ProcessRecordNodeInputProps } from '../../../container'
import styled from 'styled-components'
import { AddButon } from 'src/components'
import { cloneDeep } from 'lodash'
import variable from 'src/static/styles/var'
import { NodePreDecessorsProps } from '.'

interface InputsProps {
  className?: string
  inputs: ProcessRecordNodeInputProps[]
  nodePreDecessors: NodePreDecessorsProps[]
  onChange: (inputs: ProcessRecordNodeInputProps[]) => void
}

const Inputs: React.FC<InputsProps> = ({ className, inputs, nodePreDecessors, onChange }) => {
  const onChangeInput = (input: Partial<ProcessRecordNodeInputProps>, index: number) => {
    if (input) {
      const newInputs = cloneDeep(inputs)
      newInputs[index] = { ...newInputs[index], ...input }
      onChange(newInputs)
    } else {
      const newInputs = cloneDeep(inputs)
      newInputs.splice(index, 1)
      onChange(newInputs)
    }
  }
  return (
    <div className={className}>
      {inputs?.map((input, index) => {
        const { Type, Key, Value, Secret, SourceNodeSign, SourceKey } = input
        // 获取前置节点选项
        let SourceKeyOpts: string[] = []
        if (SourceNodeSign) {
          const node = nodePreDecessors.find(node => node.id === SourceNodeSign)
          SourceKeyOpts = Type === 'node_input' ? node?.input : node?.output
        } else {
          SourceKeyOpts = []
        }
        return (
          <div className="input_item" key={index}>
            <FormItem hideLabel value={Key} rules={{ required: true, message: '请输入Key' }}>
              <Input
                width={120}
                value={Key}
                onChangeValue={value => {
                  onChangeInput({ Key: value }, index)
                }}
              />
            </FormItem>
            <p className="equal_sign">=</p>
            <FormItem hideLabel value={Type} rules={{ required: true, message: '请选择类型' }}>
              <Select
                width={160}
                value={Type}
                onChangeValue={value => {
                  onChangeInput(
                    { Type: value, SourceKey: undefined, SourceNodeSign: undefined },
                    index
                  )
                }}
              >
                {Object.entries(InputTypeEnum).map(([value, label]) => {
                  return (
                    <Option key={value} value={value}>
                      {label}
                    </Option>
                  )
                })}
              </Select>
            </FormItem>
            {Type === 'fixed' ? (
              <>
                <FormItem hideLabel value={Value} rules={{ required: true, message: '请输入值' }}>
                  <Input
                    width={160}
                    value={Value}
                    type={Secret ? 'password' : 'text'}
                    onChangeValue={value => {
                      console.log('value', value)
                      onChangeInput({ Value: value }, index)
                    }}
                  />
                </FormItem>
                <FormItem hideLabel>
                  <Switch
                    size="default"
                    width="70"
                    value={Secret}
                    on="加密"
                    off="不加密"
                    onChangeValue={value => {
                      onChangeInput({ Secret: value }, index)
                    }}
                  ></Switch>
                </FormItem>
              </>
            ) : null}
            {Type === 'node_input' || Type === 'node_output' ? (
              <>
                <FormItem
                  hideLabel
                  value={SourceNodeSign}
                  rules={{ required: true, message: '请选择前置节点' }}
                >
                  <Select
                    width={160}
                    value={SourceNodeSign}
                    onChangeValue={value => {
                      onChangeInput({ SourceNodeSign: value, SourceKey: undefined }, index)
                    }}
                  >
                    {nodePreDecessors.map(node => {
                      return (
                        <Option key={node.id} value={node.id}>
                          {node.name}
                        </Option>
                      )
                    })}
                  </Select>
                </FormItem>
                <FormItem
                  hideLabel
                  value={SourceKey}
                  rules={{ required: true, message: '请选择前置节点Key' }}
                >
                  <Select
                    width={160}
                    value={SourceKey}
                    onChangeValue={value => {
                      onChangeInput({ SourceKey: value }, index)
                    }}
                  >
                    {SourceKeyOpts?.map(item => {
                      return (
                        <Option key={item} value={item}>
                          {item}
                        </Option>
                      )
                    })}
                  </Select>
                </FormItem>
              </>
            ) : null}
            <Icon
              className="ion-trash-a"
              size={16}
              onClick={() => {
                onChangeInput(undefined, index)
              }}
            />
          </div>
        )
      })}
      <div className="add_condition">
        <AddButon
          text="添加"
          onClick={() => {
            onChange([...inputs, { Key: '', Type: 'global' }])
          }}
        />
      </div>
    </div>
  )
}

export default styled(Inputs)`
  .input_item {
    width: 662px;
    display: flex;
    & > * {
      margin-right: 8px;
    }
    .equal_sign {
      line-height: 32px;
    }
    .k-switch {
      margin-top: 4px;
    }
    .ion-trash-a {
      width: 20px;
      text-align: center;
      line-height: 32px;
      margin-right: 0;
    }
    .k-icon {
      cursor: pointer;
      &:hover {
        color: ${variable.primaryColor};
      }
    }
  }
  .add_condition {
    width: 662px;
  }
`
